import React from 'react';
import { useSelector } from 'react-redux';
import StepWrapper from '../components/stepWrapper';
import Age from '../steps/age';
import WithOneOption from '../steps/withOneOption';
import { MultiOptions } from '../steps/multiOptions';
import Mail from '../steps/mail';
import Diet from '../steps/diet';
import Fat from '../steps/extra/fat';
import PushUps from '../steps/extra/pushUps';
import BeforeAfter from '../steps/extra/beforeAfter';
import ResultPageStep from '../steps/info/result_page_step';
import ValueAndUnits from '../steps/valueAndUnits';
import ValueAndUnitsHeight from '../steps/valueAndUnitsHeight';
import BeforeAfterB from '../steps/extra/beforeAfterB';
import XmasStartScreen from '../steps/extra/xmasStartScreen';
import BigPhotoStartScreen from '../steps/extra/bigPhotoStartScreen';
import AgeGroupStartScreen from '../steps/extra/ageGroupStartScreen';
import NewYearStartScreen from '../steps/extra/newYearStartScreen';
import stepsMan from './stepsMan';

export const stepsComponentsMan = {
	mail: (stepData) => {
		const planMan = useSelector((state) => state.global.planMan);
		const inputStyle = planMan ? 'fullBorder' : 'plain';

		return (
			<StepWrapper
				stepData={stepData}
				stepsType={stepsMan}
				customIsCompletedValidation
			>
				<Mail inputStyle={inputStyle} />
			</StepWrapper>
		);
	},
	before_after: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			customIsCompletedValidation
		>
			<BeforeAfter />
		</StepWrapper>
	),
	before_after_b: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			customIsCompletedValidation
		>
			<BeforeAfterB />
		</StepWrapper>
	),
	xmas_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			customIsCompletedValidation
		>
			<XmasStartScreen />
		</StepWrapper>
	),
	big_photo_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			customIsCompletedValidation
		>
			<BigPhotoStartScreen />
		</StepWrapper>
	),
	age_group_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			customIsCompletedValidation
		>
			<AgeGroupStartScreen />
		</StepWrapper>
	),
	zones_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			customIsCompletedValidation
		>
			<MultiOptions expandedDesign />
		</StepWrapper>
	),
	new_year_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			customIsCompletedValidation
		>
			<NewYearStartScreen />
		</StepWrapper>
	),
	age: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'age',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<Age />
		</StepWrapper>
	),
	goal: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'goal',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions largeImgDesign />
		</StepWrapper>
	),
	height: (stepData) => {
		const validationValues = {
			ft: {
				bottom: 3,
				top: 6
			},
			cm: {
				bottom: 90,
				top: 290
			}
		};

		return (
			<StepWrapper
				stepData={stepData}
				stepsType={stepsMan}
				customIsCompletedValidation
			>
				<ValueAndUnitsHeight
					validationValues={validationValues}
					questionName="height"
					stepName="height"
					singleWarning
					units={['ft', 'cm']}
					defaultUnits="ft"
					inputStyle="fullBorder"
				/>
			</StepWrapper>
		);
	},
	weight: (stepData) => {
		const validationValues = {
			lbs: {
				bottom: 80,
				top: 500
			},
			kg: {
				bottom: 35,
				top: 299
			}
		};

		return (
			<StepWrapper
				stepData={stepData}
				stepsType={stepsMan}
				customIsCompletedValidation
			>
				<ValueAndUnits
					validationValues={validationValues}
					questionName="weight"
					inputId="weight"
					stepName="weight"
					units={['lbs', 'kg']}
					defaultUnits="lbs"
					inputStyle="fullBorder"
				/>
			</StepWrapper>
		);
	},
	target_weight: (stepData) => {
		const validationValues = {
			lbs: {
				bottom: 80,
				top: 500
			},
			kg: {
				bottom: 35,
				top: 299
			}
		};

		return (
			<StepWrapper
				stepData={stepData}
				stepsType={stepsMan}
				customIsCompletedValidation
			>
				<ValueAndUnits
					validationValues={validationValues}
					questionName="target_weight"
					inputId="target_weight"
					stepName="target_weight"
					units={['lbs', 'kg']}
					defaultUnits="lbs"
					inputStyle="fullBorder"
				/>
			</StepWrapper>
		);
	},
	fat: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			customIsCompletedValidation
		>
			<Fat />
		</StepWrapper>
	),
	muscle_focus: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'muscle_focus',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	zones: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'zones',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions largeImgDesign />
		</StepWrapper>
	),
	pushUps: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			customIsCompletedValidation
			questions={[{
				name: 'pushUps',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<PushUps />
		</StepWrapper>
	),
	activities_preferences: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'activities_preferences',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions />
		</StepWrapper>
	),
	devices: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'devices',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	choose_days: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'choose_days',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions />
		</StepWrapper>
	),
	health_issues: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'health_issues',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	diet_type: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'diet_type',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<Diet />
		</StepWrapper>
	),
	successfully_lost_weight: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'successfully_lost_weight',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	previous_fails: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			questions={[{
				name: 'previous_fails',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	result_page_step: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={stepsMan}
			customIsCompletedValidation
		>
			<ResultPageStep />
		</StepWrapper>
	)
};
